/**
 * DraftingNote — amber callout for template drafting guidance.
 *
 * Renders a [GUIDANCE] segment as a labelled note (StickyNote icon + caption,
 * never colour-only) inside document-styled clause previews. The guidance
 * still flows into the generated Word document; this component only makes it
 * visible during configuration.
 */

import type { ReactNode } from 'react';
import { StickyNote } from 'lucide-react';

interface DraftingNoteProps {
  children: ReactNode;
}

export default function DraftingNote({ children }: DraftingNoteProps) {
  return (
    <aside
      className="bg-amber-50 dark:bg-amber-900/20 border-l-4 border-amber-400 rounded-r px-3 py-2 my-2 font-sans"
      aria-label="Drafting note"
    >
      <p className="flex items-center gap-1.5 text-overline uppercase text-amber-800 dark:text-amber-200">
        <StickyNote className="h-3 w-3 shrink-0" aria-hidden="true" />
        Drafting note
      </p>
      <div className="mt-0.5 text-body-sm text-amber-800 dark:text-amber-200 leading-relaxed">
        {children}
      </div>
    </aside>
  );
}
